module.exports = __webpack_public_path__ + "images/cloudpos-icon.4358cdaeae949c188bc73ed40105eca8.svg";